import PendingIcon from '@mui/icons-material/Pending';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { constants } from '../../constants';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import useMyMApi from '../../hooks/useMyMApi';
import { MyMDropDownList } from '../../ui-elements/MyMDropDownList';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMBlackLink, MyMLink } from '../../ui-elements/MyMLink';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { MyMTooltip } from '../../ui-elements/MyMToolTip';
import { BoxFileFavorite } from '../../ui-parts/ContentsFavorite';
import { CopyDialog } from '../../ui-parts/CopyDialog';
import { FilterMenu } from '../../ui-parts/FilterMenu';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import TooltipKeywordLabel from '../../ui-parts/TooltipKeywordLabel';
import { utility } from '../../utility';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';


const ThumbnailViewCard = (props) => {
  const {
    callbackFavorite,
    screenId,
    controlSettings,
    setIsLoading,
    onClickPreview,
    screenSettings,
    viewItem,
  } = props;
  const apiRequest = useMyMApi(screenId);

  const { ThumbnailFilePath, DataId, NameDisp, FileSize, Extension, UploadDate, IsFavorite, Description } = viewItem;

  const isPc = useMediaQuery(mediaQuery.pc);
  const [hovered, setHovered] = useState(false);
  const [isShareDialogOpen, setIsShareDialogOpen] = React.useState(false);
  const [shareUrl, setShareUrl] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
 
  /**
 * お気に入り(登録/解除)押下時処理
 */
  const onClickFavorite = () => {
    setIsLoading(true);
    const callbackSuccessFavorite = () => {
      callbackFavorite(DataId);
      setHovered(false)
      setIsLoading(false);
    }
    const callbackFailedFavorite = () => {
      setIsLoading(false);
    }
    apiRequest.requestJson(`api/box-file/favorite`, 'POST', callbackSuccessFavorite, callbackFailedFavorite, { Key: DataId, UnFavorite: IsFavorite })
  }

  let noImageFilePath = `${process.env.PUBLIC_URL}/${screenId}/${controlSettings.ImageList.imgNoThumbnailImage}`;
  let imageFilePath = ThumbnailFilePath ? `api/page/file?fileName=${ThumbnailFilePath}` : noImageFilePath;

  const styles = {
    fontSize: '1.15rem',
  };
  const ellipsisFileName = utility.convertEllipsisFormat(NameDisp, screenSettings.BoxFileNameMaxLength);
  const ellipsisDescription = utility.convertEllipsisFormat(Description, screenSettings.BoxDescriptionMaxLength);

  const tooltipRefs = useRef({fileName: {},description: {},});
  const [tooltipState, setTooltipState] = useState({fileName: {},description: {},});
  const handleTooltipToggle_Mobile = (type, dataId) => {
    setTooltipState((prevState) => ({
      ...prevState,
      [type]: {
        ...prevState[type],
        [dataId]: !prevState[type][dataId],
      },
    }));
  };

  const handleTooltipToggle = (DataId) => {
    setTooltipState((prevState) => ({
      ...prevState,
      [DataId]: !prevState[DataId],
    }));
  };

  const handleClickOutside = useCallback((event) => {
    ['fileName', 'description'].forEach((type) => {
      Object.keys(tooltipRefs.current[type]).forEach((id) => {
        const ref = tooltipRefs.current[type][id];
        if (ref && !ref.contains(event.target)) {
          setTooltipState((prevState) => ({
            ...prevState,
            [type]: {
              ...prevState[type],
              [id]: false,
            },
          }));
        }
      });
    });
  }, []);

  const onClickDownload = (e, fileId) => {
    setIsLoading(true);

    const downloadSuccessCallback = () => {
      setHovered(false);
      setIsLoading(false);
    }

    const downloadFailedCallback = () => {
      setIsLoading(false);
    }

    apiRequest.download(`api/box-file/download?FileId=${fileId}`, downloadSuccessCallback, downloadFailedCallback);
  }

  const currentUrl = window.location.origin;

  const onClickShare = () => {
    setIsLoading(true);

    const paramObj = { FileId: DataId };

    const successCallback = (result) => {
      setIsShareDialogOpen(true);
      setIsLoading(false);

      const basePath = '/MyM707/';
      setShareUrl(`${currentUrl}${process.env.REACT_APP_BASE_URL}${basePath}${result}`);
    };

    const failedCallback = () => {
      setIsLoading(false);
    };

    apiRequest.requestJson(
      `api/contents/encrypt-share-key?${utility.makeEncodeParameter(paramObj)}`,
      'GET',
      successCallback,
      failedCallback
    );
  };

  // クリックイベントのリスナー登録
  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);

  const textWrapperRef = useRef(null);
  const [lineCount, setLineCount] = useState(null);
  const getHeight = () => {
    if (hovered) {
      if (isPc) return '80px';
      if (lineCount === null) return null;
      return lineCount === 2 ? '80px' : '105px';
    } else {
      return isPc ? '230px' : '250px';
    }
  };

  useEffect(() => {
    if (!hovered) return; 
    const el = textWrapperRef.current;
    if (el) {
      requestAnimationFrame(() => {
        const computedStyle = window.getComputedStyle(el);
        const lineHeight = parseFloat(computedStyle.lineHeight);
        const height = el.clientHeight;
        const lines = Math.round(height / lineHeight);
        setLineCount(lines);
      });
    }
  }, [hovered, NameDisp, ellipsisFileName]);

  return (
    <Grid item xs={isPc ? 3 : 12} lg={3}  >
      <MyMLabel></MyMLabel>
      <Card sx={{ border: '2px solid #D4D4D4', borderRadius: '10px', height: isPc ? '230px' :'250px', width: '100%'}}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={async () => {
          setHovered(false);
        }
        }
      >
        <Box sx={{ position: 'relative', transition: 'opacity 0.2s ease-in-out', }}>

          <Box padding=' 0 20px' height={getHeight()} width='100%' sx={{ textAlign: 'center', position: 'relative', backgroundColor: 'rgb(13 13 13 / 55%)' }} className="d-flex align-items-center justify-content-center">
            <img
              src={imageFilePath}
              className='d-inline'
              alt=''
              style={{
                maxWidth: '250px',
                width: 'auto',
                height: '100%',
                objectFit: 'contain',
                cursor: 'pointer'
              }}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = noImageFilePath;
              }}
              onClick={(e) => { onClickPreview(e, DataId); setHovered(false); }}
            />
            <Box sx={{ position: 'absolute', top: '0px', right: '0px' }}>
              <BoxFileFavorite isFavorite={IsFavorite} favoriteAction={onClickFavorite} unFavoriteAction={onClickFavorite} color='white' />
            </Box>
          </Box>
          <CardContent sx={{
            padding: isPc?'5px':'0px 5px',
            '&:last-child': {
              paddingBottom: isPc ? '5px' : '0px',
            },
          }} >

            {hovered &&
              <Box sx={{ height: isPc ? '145px' : '100%', overflow: 'hidden' }}>
                <MyMBlackLink component='a' sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center'}} notUseLabel={true} onClick={(e) => { onClickPreview(e, DataId); setHovered(false); }}>
                  <div ref={textWrapperRef} style={{ display: 'inline-block' }}>
                  <TooltipKeywordLabel
                    keyword=''
                    toolTipValue={(NameDisp !== ellipsisFileName) && NameDisp}
                    value={ellipsisFileName}
                    fontSize={styles.fontSize}
                    isEllipsis={NameDisp !== ellipsisFileName}
                    />
                  </div>
                  {!isPc && NameDisp !== ellipsisFileName &&
                    <div ref={(el) => tooltipRefs.current.fileName[DataId] = el}>
                      <MyMTooltip
                        title={NameDisp}
                        arrow
                        open={(tooltipState.fileName[DataId] || false) && hovered}
                        onClose={() => handleTooltipToggle_Mobile('fileName', DataId)}
                        onOpen={() => handleTooltipToggle_Mobile('fileName', DataId)}
                      >
                        <IconButton
                          sx={{ marginLeft: "10px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleTooltipToggle_Mobile('fileName', DataId);
                          }}
                        >
                          {/* 2026.2.25 タブレット表示時対応 Modify Start */}
                          <PendingIcon fontSize='small' />
                          {/* 2026.2.25 タブレット表示時対応 Modify End */}
                        </IconButton>
                      </MyMTooltip>
                    </div>
                    }

                </MyMBlackLink>
                <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                  {
                    Description !== null ?
                      Description !== ellipsisDescription ?
                        isPc ?
                          <Grid item lg={12}>
                            <MyMTooltip
                              title={Description}
                              arrow
                              open={(tooltipState[DataId] || false)}
                              onClose={() => handleTooltipToggle(DataId)}
                              onOpen={() => handleTooltipToggle(DataId)}

                            >
                              <MyMLabel fontSize='0.8rem'>
                                {ellipsisDescription}
                              </MyMLabel>
                            </MyMTooltip>
                          </Grid>
                          :
                          <div ref={(el) => tooltipRefs.current.description[DataId] = el}>
                            <MyMTooltip
                              title={Description}
                              arrow
                              open={(tooltipState.description[DataId] || false) && hovered}
                              onClose={() => handleTooltipToggle_Mobile('description', DataId)}
                              onOpen={() => handleTooltipToggle_Mobile('description', DataId)}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <MyMLabel fontSize='11.5px'>
                                  {ellipsisDescription}
                                </MyMLabel>
                                <IconButton
                                  sx={{ padding: 0, paddingLeft:'10px' }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleTooltipToggle_Mobile('description', DataId);
                                  }}
                                >
                                  <PendingIcon fontSize='small'/>
                                </IconButton>
                              </Box>
                            </MyMTooltip>
                          </div>
                        :
                        <>
                          <Grid item lg={12}>
                            <MyMLabel fontSize='0.9rem'>
                              {Description}
                            </MyMLabel>
                          </Grid>
                        </>
                      :
                      <Grid item lg={12}>
                        <MyMLabel>{' '}</MyMLabel>
                      </Grid>                       
                  }
                  
                </Grid>
                <Grid container >
                  <Grid item xs={6} lg={6}>
                    <MyMLabel fontSize='0.95rem'>
                      {controlSettings.LabelList.lblFileSizeTitle}
                    </MyMLabel >
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <MyMLabel fontSize='0.95rem'>
                      {FileSize != null ? `${utility.convertFileSize(FileSize, constants.FileSize.MB)?.toFixed(1)}${controlSettings.LabelList.lblFileSizeUnit}` : ''}
                    </MyMLabel >
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <MyMLabel fontSize='0.95rem'>
                      {controlSettings.LabelList.lblFileTypeTitle}
                    </MyMLabel >
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <MyMLabel fontSize='0.95rem'>
                      {Extension && Extension.toUpperCase()}
                    </MyMLabel >
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <MyMLabel fontSize='0.95rem'>
                      {controlSettings.LabelList.lblUploadDateTitle}
                    </MyMLabel>
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <MyMLabel fontSize='0.95rem'>
                      {utility.formatDateTime(UploadDate, 'd MMMM yyyy')}
                    </MyMLabel>
                  </Grid>
                </Grid>
                {/*<MyMLabel>{lineCount === 2 ?'1':'2'} </MyMLabel>*/}
                <Box className='text-center'>
                  <MyMLink onClick={(e) => { onClickPreview(e, DataId); setHovered(false); }}>{controlSettings.LabelList.lnkPreview}</MyMLink>
                  <MyMLabel component='span'>{controlSettings.LabelList.lblSeparate}</MyMLabel>
                  <MyMLink onClick={(e) => { onClickDownload(e, DataId) }}>{controlSettings.LabelList.lnkDownload}</MyMLink>
                  <MyMLabel component='span'>{controlSettings.LabelList.lblSeparate}</MyMLabel>
                  <BoxFileFavorite isFavorite={IsFavorite} favoriteAction={onClickFavorite} unFavoriteAction={onClickFavorite} />
                  <MyMLabel component='span'>{controlSettings.LabelList.lblSeparate}</MyMLabel>
                  <ShareOutlinedIcon onClick={(e) => { onClickShare(e, DataId) }} sx={{ cursor: 'pointer', color: '#77787B', fontSize: '20px' }} />
                </Box>
              </Box>
            }
          </CardContent>
          <CopyDialog
            isOpen={isShareDialogOpen}
            onClose={() => { setIsShareDialogOpen(false); setHovered(false); }}
            copyText={shareUrl}
            screenId={screenId}
          />
          {isModalOpen && <MyMModal
            open={isModalOpen}
            onClose={handleModalClose}
            {...previewModalSize}
          >
            <Preview fileId={false} onPreviewFailed={handleModalClose} />
          </MyMModal>}
        </Box>
      </Card>
    </Grid>
  );
}

const AssetLibraryCard = (props) => {
  const {
    screenId,
    searchResult,
    onSortByChange,
    onClickPreview,
    controlSettings,
    messageList,
    sortByDDL,
    selectedSortBy,
    setIsLoading,
    screenSettings,
    isLoading,
    metadataList,
    setApliableFilterList,
    checkedList,
    setCheckedList,
    scrollRequestSearch,
    hasMore
  } = props;

  const theme = useTheme();

  /**
   * お気に入りコールバック処理
   * @param {number} favoriteFileId お気に入りファイルID
   */
  const callbackFavorite = (favoriteFileId) => {
    const favoriteFile = searchResult.ItemList.find(x => x.DataId === favoriteFileId);
    // お気に入り情報を更新
    favoriteFile.IsFavorite = !favoriteFile.IsFavorite;
  }
  const isPc = useMediaQuery(mediaQuery.pc);
  const [isOpenFilterMenu, setIsOpenFilterMenu] = useState(false);
  const openFilterMenu = () => setIsOpenFilterMenu(true);
  const closeFilterMenu = () => setIsOpenFilterMenu(false);

  return (
    <OutlinedCustomCard isAsset={true}>
      <CardHeader
        sx={{ display: 'flex', background: theme.palette.background.secondary, height: '9%' }}
        title={''}
        action={
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <MyMDropDownList
              autoWidth={false}
              value={selectedSortBy}
              onChange={onSortByChange}
              options={sortByDDL.map((data) => ({
                value: data.value,
                text: data.text
              }))}
              sx={{ color: 'white', width: isPc ? 300 : 'calc(100% - 20px)' }} // 300pxで固定
            />
            {!isPc &&
              <Box sx={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                <FilterMenu
                  isOpenFilterMenu={isOpenFilterMenu}
                  openFilterMenu={openFilterMenu}
                  closeFilterMenu={closeFilterMenu}
                  content={metadataList}
                  controlSettings={controlSettings}
                  setApliableFilterList={setApliableFilterList}
                  checkedList={checkedList}
                  setCheckedList={setCheckedList}
                />
              </Box>
            }
          </Box>
        }
      />
      <CardContent
        id="scrollableDiv"
        sx={{ height: 580, overflowY: 'auto', paddingTop: '5px', paddingLeft: isPc ? '40px' : '20px', paddingRight: isPc ? '40px' : '20px' }}>
        {searchResult.ItemList.length === 0
          ? <MyMLabel className='d-flex justify-content-center'>{messageList.MyM_MSG_I_0059}</MyMLabel>
          :
          <>
            <MyMLabel>{controlSettings.LabelList.lblTotalNumberTitle} {searchResult.TotalRecordCount}</MyMLabel>
            <InfiniteScroll
              dataLength={searchResult.ItemList.length}
              next={scrollRequestSearch}
              hasMore={hasMore}
              loader={isLoading && <MyMProgress />}
              scrollableTarget="scrollableDiv"
              style={{ overflow: 'visible' }}
            >
              {isLoading && <MyMProgress />}
              <Grid container spacing={1} mb={2} >
                {
                  searchResult.ItemList.map((item) =>
                    <ThumbnailViewCard
                      key={item.DataId}
                      callbackFavorite={callbackFavorite}
                      screenId={screenId}
                      setIsLoading={setIsLoading}
                      onClickPreview={onClickPreview}
                      screenSettings={screenSettings}
                      controlSettings={controlSettings}
                      viewItem={item}
                    />

                  )
                }
              </Grid>
            </InfiniteScroll>
          </>
        }
      </CardContent>
    </OutlinedCustomCard>
  );
}
export default AssetLibraryCard;